var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finish-page"},[_c('img',{attrs:{"src":require("@/assets/img/guide/finish.svg"),"alt":""}}),_c('p',{staticClass:"finish-title"},[_vm._v("恭喜你已全部配置完成啦~")]),_c('p',{staticClass:"finish-subtitle"},[_vm._v("下面可以开始给客户演示啦~")]),_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.skip}},[_vm._v("前往客户演示模块")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }